import { useLocation } from 'react-router-dom'

import { getPluginSlots } from '@/plugin/slots'
import { matchPublicShareRoute } from '@/constants/public-share-routes'
import { ExternalApplyCompletePage, ExternalApplyPage } from '@/components/external-apply/external-apply-page'
import { PublicJobPage } from '@/components/public/public-job-page'
import { PublicOrganisationPage } from '@/components/public/public-organisation-page'
import { InterviewJoinPage } from '@/components/interview/interview-join-page'
import { PublicProfilePage } from '@/components/public/public-profile-page'

export function PublicShareRoutes() {
  const { pathname } = useLocation()
  const pluginRoutes = getPluginSlots().publicShareRoutes
  const match = matchPublicShareRoute(pathname, pluginRoutes)

  if (match?.kind === 'interview') {
    return <InterviewJoinPage key={pathname} tokenOverride={match.token} />
  }

  if (match?.kind === 'plugin') {
    const route = pluginRoutes[match.index]
    if (route) {
      const Page = route.element
      return <Page key={pathname} />
    }
  }

  if (match?.kind === 'apply-complete') {
    return <ExternalApplyCompletePage key={pathname} tokenOverride={match.token} />
  }

  if (match?.kind === 'apply') {
    return <ExternalApplyPage key={pathname} jobIdOverride={match.jobId} />
  }

  if (match?.kind === 'job') {
    return <PublicJobPage key={pathname} slugOverride={match.slug} />
  }

  if (match?.kind === 'organisation') {
    return <PublicOrganisationPage key={pathname} slugOverride={match.slug} />
  }

  if (match?.kind === 'profile') {
    return <PublicProfilePage key={pathname} slugOverride={match.slug} />
  }

  return null
}
